module.exports = __webpack_public_path__ + "99b5895ac70d3b0782c8fb28c91afebc.jpg";